import { Routes } from '@angular/router';
import {
  LockEntityGuard,
  ReleaseListGuard,
  releaseLockGuard,
  signedInGuard,
  SignedOutComponent,
  stockAppForwardGuard,
  unsavedChangesGuard,
} from 'shared';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { BlankLayoutComponent } from './layouts/blank-layout/blank-layout.component';
import {
  SupplierInvoiceDetailComponent
} from '@features/purchase/supplier-invoices/supplier-invoice-detail/supplier-invoice-detail.component';
import {
  SupplierCreditNoteDetailsComponent
} from '@features/purchase/supplier_credit_notes/supplier-credit-note-details/supplier-credit-note-details.component';

export const routes: Routes = [
  { path: 'signed-out', title: 'SIGNED_OUT_PAGE_TITLE', component: SignedOutComponent, canActivate: [stockAppForwardGuard] },
  {
    path: '',
    component: MainLayoutComponent,
    // Leaving a form with changes that aren't saved asks first
    canActivateChild: [unsavedChangesGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        title: 'DASHBOARD',
        canActivate: [signedInGuard],
        loadChildren: () => import('./features/dashboard/routes').then((m) => m.DASHBOARD_ROUTES),
      },
      {
        path: 'clients',
        title: 'CLIENTS',
        canActivate: [signedInGuard],
        canDeactivate: [ReleaseListGuard],
        loadChildren: () => import('./features/clients/routes').then((m) => m.CLIENT_ROUTES),
      },
      {
        path: 'purchase',
        title: 'PURCHASE',
        canActivate: [signedInGuard],
        loadChildren: () => import('./features/purchase/purchase.routes').then((m) => m.PURCHASE_ROUTES),
      },
      {
        path: 'sales',
        title: 'SALES',
        canActivate: [signedInGuard],
        loadChildren: () => import('./features/sales/sales.routes').then((m) => m.SALES_ROUTES),
      },
      {
        path: 'suppliers',
        title: 'SUPPLIERS',
        canActivate: [signedInGuard],
        loadChildren: () => import('./features/suppliers/routes').then((m) => m.SUPPLIER_ROUTES),
      },
      {
        path: 'supplier_articles',
        title: 'ARTICLES',
        canActivate: [signedInGuard],
        loadChildren: () => import('./features/articles/routes').then((m) => m.ARTICLE_ROUTES),
      },
      {
        path: 'settings',
        title: 'SETTINGS',
        canActivate: [signedInGuard],
        loadChildren: () => import('./features/settings/routes').then((m) => m.SETTING_ROUTES),
      },
      {
        path: 'users',
        title: 'USER_SETTINGS',
        canActivate: [signedInGuard],
        loadChildren: () => import('./features/users/routes').then((m) => m.USER_ROUTES),
      },
      {
        path: 'warehouse',
        title: 'WAREHOUSE',
        canActivate: [signedInGuard],
        loadChildren: () => import('./features/warehouse/routes').then((m) => m.WAREHOUSE_ROUTES),
      },
      {
        path: 'complaints',
        title: 'COMPLAINTS',
        canActivate: [signedInGuard],
        loadChildren: () => import('./features/complaints/routes').then((m) => m.COMPLAINT_ROUTES),
      },
      {
        path: 'document_library_folders',
        title: 'INTRANET',
        canActivate: [signedInGuard],
        loadChildren: () => import('./features/intranet/routes').then((m) => m.INTRANET_ROUTES),
      },
      {
        path: 'communication',
        title: 'COMMUNICATION',
        canActivate: [signedInGuard],
        loadChildren: () => import('./features/communication/routes').then((m) => m.COMMUNICATION_ROUTES),
      },
      {
        path: 'user_medias',
        title: 'FILES',
        canActivate: [signedInGuard],
        loadChildren: () => import('./features/files/routes').then((m) => m.FILE_ROUTES),
      },
      {
        path: 'royal_crown_employees',
        title: 'EMPLOYEES',
        canActivate: [signedInGuard],
        loadChildren: () => import('./features/employees/routes').then((m) => m.EMPLOYEE_ROUTES),
      },
      {
        path: 'logs',
        title: 'LOGS',
        canActivate: [signedInGuard],
        loadChildren: () => import('./features/logs/logs.routes').then((m) => m.LOGS_ROUTES),
      },
    ],
  },

  {
    path: '',
    component: BlankLayoutComponent,
    children: [
      {
        path: 'purchase/supplier_invoices/:supplierInvoiceId',
        title: 'SUPPLIER_INVOICE',
        canActivate: [signedInGuard, LockEntityGuard],
        component: SupplierInvoiceDetailComponent,
        canDeactivate: [releaseLockGuard],
        data: { signalKey: 'supplierInvoice' },
        runGuardsAndResolvers: 'always',
      },
      {
        path: 'purchase/supplier_credit_notes/:supplierCreditNoteId',
        title: 'SUPPLIER_CREDIT_NOTE',
        canActivate: [signedInGuard, LockEntityGuard],
        component: SupplierCreditNoteDetailsComponent,
        canDeactivate: [releaseLockGuard],
        data: { signalKey: 'supplierCreditNote' },
        runGuardsAndResolvers: 'always',
      },
    ],
  },

  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  { path: '**', redirectTo: '/dashboard' },
];
